import React, { useMemo, useState } from 'react';
import {
  CardWrap,
  TabsBar,
  TabItem,
  Panel,
  SectionTitle,
  TableHeadRow,
  TableRowStyled,
  Cell,
  IconSquare,
} from '../styles';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ScheduleIcon from '@mui/icons-material/Schedule';

const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      })
    : '—';

// 🔴 ONLY THIS FUNCTION CHANGED
const rowFromDoc = (doc) => {
  const item = doc?.itemId;                 // populated on dashboard
  const med  = item?.medicineId || doc?.medicineId; // fallback for any old data

  // Name:
  // - Medicine → brandName / genericName
  // - Product  → item.name
  let name = '—';
  if (med) {
    name = med.brandName || med.genericName || item?.name || '—';
  } else if (item?.name) {
    name = item.name;
  }

  // Strength: still use batch strength; mainly relevant for medicines
  const strength = doc?.strength || '';

  const batch  = doc?.batchNo || doc?.batch || '—';
  const expiry = fmtDate(doc?.expiryDate);

  const qtyNum =
    typeof doc?.quantity === 'number'
      ? doc.quantity
      : typeof doc?.qty === 'number'
      ? doc.qty
      : null;

  const qty = qtyNum !== null ? `${qtyNum} units` : '—';

  const isExpired = doc?.expiryDate ? new Date(doc.expiryDate) < new Date() : false;

  return { name, strength, batch, expiry, qty, status: isExpired ? 'Expired' : 'OK' };
};

const MedicineTabs = ({
  expiringSoon,
  recentlyAdded,
  titleExpiring = 'Next to Expire',
  titleRecent = 'Recently Added Items',
}) => {
  const [tab, setTab] = useState(0);

  // Map backend docs → table rows once (memoized)
  const expiringRows = useMemo(() => expiringSoon.map(rowFromDoc), [expiringSoon]);
  const recentRows   = useMemo(() => recentlyAdded.map(rowFromDoc), [recentlyAdded]);

  const rows = tab === 0 ? expiringRows : recentRows;

  const sectionTitle = tab === 0 ? titleExpiring : titleRecent;

  return (
    <CardWrap>
      {/* Tabs */}
      <TabsBar>
        <TabItem $active={tab === 0} onClick={() => setTab(0)}>
          <IconSquare
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: tab === 1 && '#ededed',
              color: tab === 1 && '#00000099',
            }}
          >
            <ErrorOutlineIcon sx={{ color: tab === 1 && '#00000099' }} />
          </IconSquare>
          Expiring Soon
        </TabItem>

        <TabItem $active={tab === 1} onClick={() => setTab(1)}>
          <IconSquare
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: tab === 0 && '#ededed',
              color: tab === 0 && '#00000099',
            }}
          >
            <ScheduleIcon sx={{ color: tab === 0 && '#00000099' }} />
          </IconSquare>
          Recently Added
        </TabItem>
      </TabsBar>

      {/* Panel */}
      <Panel>
        <SectionTitle>{sectionTitle}</SectionTitle>

        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <TableHeadRow>
              <Cell style={{ minWidth: '100px' }} as="th">
                Item
              </Cell>
              <Cell style={{ minWidth: '100px' }} as="th">
                Batch
              </Cell>
              <Cell style={{ minWidth: '100px' }} as="th">
                Expiry Date
              </Cell>
              <Cell style={{ minWidth: '100px' }} as="th">
                Quantity
              </Cell>
              {/* <Cell as="th">Status</Cell> */}
            </TableHeadRow>
          </thead>

          <tbody>
            {rows.length === 0 ? (
              <TableRowStyled>
                <Cell colSpan={5} style={{ padding: '24px 0', color: '#6b7280' }}>
                  {tab === 0 ? 'No upcoming expiries.' : 'No recent batches.'}
                </Cell>
              </TableRowStyled>
            ) : (
              rows.map((r, i) => (
                <TableRowStyled key={i}>
                  <Cell sx={{ width: '100% !important' }}>
                    <IconSquare />
                    <div>
                      <strong>{r.name}</strong>
                      {r.strength ? (
                        <>
                          <br />
                          <small>{r.strength}</small>
                        </>
                      ) : null}
                    </div>
                  </Cell>
                  <Cell>{r.batch}</Cell>
                  <Cell>{r.expiry}</Cell>
                  <Cell>{r.qty}</Cell>
                </TableRowStyled>
              ))
            )}
          </tbody>
        </table>
      </Panel>
    </CardWrap>
  );
};

export default MedicineTabs;
